document.addEventListener('DOMContentLoaded', (event) => {
  Sceon.PhotoRoller = {};
  Sceon.PhotoRoller.timer = null;
  Sceon.PhotoRoller.index = 0;
  Sceon.PhotoRoller.src = null;
  Sceon.PhotoRoller.thumb = null;
  Sceon.PhotoRoller.previousEl = null;

  Sceon.PhotoRoller.init = function () {
    Sceon.PhotoRoller.timer = null;
    Sceon.PhotoRoller.previousEl = null;
    Sceon.PhotoRoller.index = 0;
    Sceon.PhotoRoller.src = null;
    Sceon.PhotoRoller.thumb = null;

    $('.main-listing-container')
      .find('.profile-photo')
      .each(function (ind, el) {
        $(el).mouseenter(function () {
          Sceon.PhotoRoller.roll(el);
        });
        $(el).mouseleave(function () {
          Sceon.PhotoRoller.removeRoll(el);
        });
        $(el).on('touchstart', function () {
          if (Sceon.PhotoRoller.previousEl) {
            Sceon.PhotoRoller.removeRoll(Sceon.PhotoRoller.previousEl);
          }
          Sceon.PhotoRoller.roll(el);
        });
        $(el).click(function () {
          Sceon.PhotoRoller.removeRoll(el);
        });
      });
  };

  Sceon.PhotoRoller.roll = function (el) {
    if (!$(el).attr('data-srcs')) {
      return;
    }
    if (!$(el).attr('src')) {
      return;
    }
    let srcs = JSON.parse($(el).attr('data-srcs'));
    if (!Sceon.PhotoRoller.src) {
      Sceon.PhotoRoller.src = $(el).attr('src');
      Sceon.PhotoRoller.thumb = $(el)
        .attr('src')
        .match(/thumb_\d+/i)[0];
    }
    if (!$(el).attr('data-src')) {
      $(el).attr('data-src', $(el).attr('src'));
    }
    Sceon.PhotoRoller.previousEl = el;
    if (srcs.length) {
      if (Sceon.PhotoRoller.index >= srcs.length) {
        Sceon.PhotoRoller.index = 0;
      }
      let src = srcs[Sceon.PhotoRoller.index].replace(
        /thumb_\d+/i,
        Sceon.PhotoRoller.thumb,
      );
      if (src != '') {
        $(el).attr('src', src);
      }
      if (Sceon.PhotoRoller.timer) {
        clearTimeout(Sceon.PhotoRoller.timer);
      }

      Sceon.PhotoRoller.index++;

      Sceon.PhotoRoller.timer = setTimeout(function () {
        Sceon.PhotoRoller.roll(el);
      }, 2000);
    }
  };

  Sceon.PhotoRoller.removeRoll = function (el) {
    clearTimeout(Sceon.PhotoRoller.timer);
    Sceon.PhotoRoller.timer = null;
    if ($(el).attr('data-src')) {
      $(el).attr('src', $(el).attr('data-src'));
    } else if (Sceon.PhotoRoller.src) {
      $(el).attr('src', Sceon.PhotoRoller.src);
    }
    Sceon.PhotoRoller.src = null;
    Sceon.PhotoRoller.previousEl = null;
    Sceon.PhotoRoller.index = 0;
  };
});
